import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import api from 'src/api';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditBidForm({ item, selectedGame, getAllShowWinners }) {
  const [open, setOpen] = React.useState(false);
  const [openPanna, setOpenPanna] = React.useState(item?.open_panna);
  const [closePanna, setClosePanna] = React.useState(item?.close_panna);
  const [closeDigit, setCloseDigit] = React.useState(item?.close_digit);
  const [openDigit, setOpenDigit] = React.useState(item?.open_digit);
  const [session, setSession] = React.useState(item?.session);
  const [points, setPoitns] = React.useState(item?.points);
  const [loading, setLoading] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const editBidHandler = async (isDeleted) => {
    let reqBody = {};

    if (isDeleted) {
      reqBody = {
        isDelete: isDeleted,
        bidIdToUpdate: item._id,
        result_id: selectedGame?._id,
      };
    } else {
      reqBody = {
        result_id: selectedGame?._id,
        newBidData: {
          close_panna: closePanna,
          open_panna: openPanna,
          open_digit: openDigit,
          session: session,
          close_digit: closeDigit,
          points: points,
        },
        bidIdToUpdate: item._id,
      };
    }
    setLoading(true);
    await api.put('/pending-results/update-bid', reqBody);
    setLoading(false);
    handleClose();
    getAllShowWinners();
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        ACTION
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Use Google's location service?"}</DialogTitle>
        <DialogContent>
          <Stack direction="column">
            <br />

            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Session</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={session}
                label="Session"
                onChange={(e) => setSession(e.target.value)}
              >
                <MenuItem disabled={selectedGame && !selectedGame?.is_open_pending} value={'open'}>
                  Open
                </MenuItem>
                <MenuItem disabled={selectedGame && !selectedGame?.is_close_pending} value={'close'}>
                  Close
                </MenuItem>
              </Select>
            </FormControl>

            <br />
            <TextField
              inputProps={{ maxLength: 3 }}
              name="openPaana"
              label="Open Panna"
              value={openPanna}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setOpenPanna(e.target.value)}
            />
            <br />
            <TextField
              inputProps={{ maxLength: 1 }}
              name="openDigit"
              InputLabelProps={{
                shrink: true,
              }}
              label="Open Digit"
              value={openDigit}
              onChange={(e) => setOpenDigit(e.target.value)}
            />
            <br />

            <TextField
              inputProps={{ maxLength: 3 }}
              InputLabelProps={{
                shrink: true,
              }}
              name="closePaana"
              label="Close Panna"
              value={closePanna}
              onChange={(e) => setClosePanna(e.target.value)}
            />
            <br />

            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{ maxLength: 1 }}
              name="closeDigit"
              label="Close Digit"
              value={closeDigit}
              onChange={(e) => setCloseDigit(e.target.value)}
            />

            <br />

            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              name="points"
              label="Points"
              value={points}
              onChange={(e) => setPoitns(e.target.value)}
            />
            <br />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton
            color="error"
            loading={loading}
            size="small"
            type="submit"
            onClick={() => editBidHandler(true)}
          >
            DELETE
          </LoadingButton>

          <LoadingButton
            color="success"
            loading={loading}
            size="small"
            type="submit"
            variant="contained"
            onClick={() => editBidHandler()}
          >
            UPDATE
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
